import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract'
import { sortByMultiField } from '@/utils'
import { TabError } from '@/utils/class/TabError'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { ensureExecuteSuccess, deepCopy, cleanCircleObject } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { Company } from '@/class/model/mdm/Company'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { checkCreditInfo } from '@/api/partner/creditInfo'
import { batchAddJob, batchRemoveJob, batchDeleteJob } from '@/api/booking/job'
import { batchCloneLcLJob } from '@/api/railwayExport/reBooking'
import { checkJobForShared } from '@/api/seaExport/seaExportJob'
import { getWarehouseDetail } from '@/api/company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import $store from '@/store'

export class TabBookingMasterPM extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.isWithinCloseAccountDate = false // withinCloseAccountDate
  }
  get salesOfficeCheck() {
    return this.view.salesOfficeCheck
  }
  set salesOfficeCheck(salesOfficeCheck) {
    this.view.salesOfficeCheck = salesOfficeCheck
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  changeJob() {
    if (this.job.uuid) {
      this.view.txtWhs = JobUtils.getWarehouseInDetail(this.job.warehouseIn)
    }
    const warehouseInfo = this.job.warehouseInfo
    if (warehouseInfo.length > 0) {
      this.job.warehouseCmp = warehouseInfo[0].warehouseCmp
    }
    const trucking = this.job.trucking
    if (trucking.length > 0) {
      // 需要排序，因为业务调整更新的 TruckingId desc排序后的第一条，要及时反馈出来
      sortByMultiField(trucking, ['truckingId'], true)
      this.job.carryingCmp = trucking[0].carryingCmp
    }
    ContainerUtil.refreshContainerSeaEQ(this.job)
  }
  fillView() {
    const job = this.job
    if (!job.uuid) {
      job.containerLoadType = 'LCL'
      ensureExecuteSuccess(() => {
        return !!this.view.$refs.customJobType
      }).then(() => {
        this.selectDefaultCutomJobType()
      })
      JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, null, true)
    }
    this.getSailingDay()
    this.loadCompanyOffice()
    this.loadOverseaOpChanged()
    this.loadOverseaAgentChanged()
  }
  /**
   * 投保
   */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      billno: this.job.mbl,
      insureType: 'JOB'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: this.view.$store.getters.currentOfficeId,
    //     billno: this.job.mbl,
    //     insureType: 'JOB'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel("RE-基本-投保");
    // }
    // const job = deepCopy(this.job)
    // cleanCircleObject(job)
    // RailwayExportJob.toInsure(job, this.context.office).then(data => {
    //   this.insureSuccessHandler(data)
    // })
  }
  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.$message.warning(result)
  //   }
  // }
  // 获取开航日期后面的星期几
  getSailingDay() {
    if (this.job.etd) {
      this.job.sailingDay = String(new Date(this.job.etd)).substr(0, 3).toUpperCase()
    } else {
      this.job.sailingDay = ''
    }
  }
  loadCompanyOffice() {
    const job = this.job
    const office = this.context.officeList.filter(p => p.officeId === job.salesOffice)[0]
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  /**
   * 加载海外客服信息
   */
  async loadOverseaOpChanged() {
    const job = this.job
    if (Number(job.overseaOp) > 0) {
      const user = this.userList.filter(p => p.userId === Number(job.overseaOp))[0]
      await this.overseaOpChangeHandler({ ...user, value: job.overseaOp })
    }
  }
  /**
   * 加载海外客服
   */
  async loadOverseaAgentChanged() {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    if (Number(job.destinationAgent) > 0) {
      const company = await Company.getCompanyById(Number(job.destinationAgent))
      if (company) {
        await this.loadDestinationAgentDetai2Handler(company)
      } else {
        job.overseaOp = 0
        job.overseaOpDepartment = 0
      }
    }
  }
  async loadDestinationAgentDetai2Handler(company) {
    if (company) {
      company = new Company(company)
      const agent = await company.getOverseaAgentDetail()
      if (agent) {
        this.loadOverseaAgentUser2Handler(agent)
      }
    }
  }
  async loadOverseaAgentUser2Handler(overseaAgent) {
    if (this.view.isHC) {
      return
    }
    overseaAgent = new OverseaAgent(overseaAgent)
    const job = this.job
    const overseaAgentUsers = await overseaAgent.getOverseaAgentUserList()
    // 海外客服
    const overseaAgentUsersList = []
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (var u of overseaAgentUsers) {
        if (u.lob === job.lob || !u.lob || u.lob === 'ALL') {
          const user = this.userList.filter(p => p.userId === u.userId)[0]
          if (user) {
            if (u.roleType === 5) { // 海外客服
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaOpList = overseaAgentUsersList
  }
  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    let options = this.view.$refs.customJobType.options
    options = options.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  /**
 * 揽货类型选择
 */
  async cargoSourceChange() {
    const job = this.job
    this.loadDestinationAgentDetaiHandler()
    const options = this.context.seaPortList
    const company = await Company.getCompanyById(job.destinationAgent)
    if (job.cargoSource === 'NC') { // 如果是指定货
      const cmp = options.filter(p => p.cmpIdx === job.designationAgent)[0]
      this.loadOverseaAgentUserByLob(cmp)// 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(company)// 还是根据目的港代理确定海外客服
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
  }
  async loadDestinationAgentDetaiHandler(company) {
    if (company) {
      company = new Company(company)
      const agent = await company.getOverseaAgentDetail()
      if (agent) {
        this.loadOverseaAgentUserHandler(agent)
      }
    }
  }
  async loadOverseaAgentUserHandler(overseaAgent) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    // 海外客服
    const overseaAgentUsersList = []
    if (overseaAgent) {
      overseaAgent = new OverseaAgent(overseaAgent)
      const overseaAgentUsers = await overseaAgent.getOverseaAgentUserList()
      if (overseaAgentUsers && overseaAgentUsers.length > 0) {
        for (var u of overseaAgentUsers) {
          if (u.lob === job.lob || !u.lob || u.lob === 'ALL') {
            const user = this.userList.filter(p => p.userId === u.userId)[0]
            if (user) {
              if (u.roleType === 5) { // 海外客服
                overseaAgentUsersList.push(user)
              }
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaOpList = overseaAgentUsersList
    if (overseaAgentUsersList.length > 0) {
      const user = overseaAgentUsersList[0]
      job.overseaOp = user.userId
      this.overseaOpChangeHandler({ ...user, value: user.userId })
    } else {
      job.overseaOp = 0
      job.overseaOpDepartment = 0
    }
  }
  /**
   * 按业务指定海外客服
   */
  loadOverseaAgentUserByLob(company) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    if (company) {
      this.loadDestinationAgentDetaiHandler(company)
    } else {
      job.overseaOp = 0
      job.overseaOpDepartment = 0
      this.view.overseaOpList = []
    }
  }
  txtDesignationAgentChangeHandler(data) {
    this.view.showDesignationAgentWarning = false
    this.checkCreditByCompany(data.value, 'designationAgent')
    const job = this.job
    job.designationAgent = data.value
    if (job.cargoSource === 'NC') { // 如果是指定货, 则更新海外客服
      this.loadOverseaAgentUserByLob(data)
    }
  }
  /**
   * 本地服务选择
   */
  loadingTermChange(fieldName) {
    const job = this.job
    if (fieldName === 'warehousing') {
      if (!job.warehousing) {
        job.warehouseCmp = 0
        job.warehouseRecord = 0
        const warehouseInfo = job.warehouseInfo
        if (warehouseInfo && warehouseInfo.length > 0) {
          for (const item of warehouseInfo) {
            item.deleted = true
            this.removeWarehouseFromModifiedSet(item)
          }
          warehouseInfo.splice(0, warehouseInfo.length)
        }
      }
      this.view.$emit('resetTab', 'tabWarehouse')
    } else if (fieldName === 'landTransportation') {
      if (!job.landTransportation) {
        job.carryingCmp = 0
        /* 取消勾选客户门点/提货，清空客户门点页签信息 */
        const trucking = job.trucking
        if (trucking && trucking.length > 0) {
          for (const item of trucking) {
            this.removeTruckingFromModifiedSet(item)
          }
          trucking.splice(0, trucking.length)
        }
      }
      this.view.$emit('resetTab', 'tabTrucking')
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    if (warehouse.uuid) {
      const removedData = this.context.removedData
      removedData.warehouseInfo = removedData.warehouseInfo || []
      removedData.warehouseInfo.push(warehouse)
    }
  }
  // 将truckingInfo从被修改的集合中移除
  removeTruckingFromModifiedSet(truckingInfo) {
    if (truckingInfo.uuid) {
      const removedData = this.context.removedData
      removedData.delTruckingInfoUuids = removedData.delTruckingInfoUuids || []
      removedData.delTruckingInfoUuids.push(truckingInfo.uuid)
    }
  }
  /**
   * item代表不同的表单项
   */
  checkCreditByCompany(companyId, item) {
    const callback = credit => {
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          const config = this.getCreditEDISetting()
          if (config.booking) {
            if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
            if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
            if (tip !== '') {
              const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
              if (item === 'designationAgent') {
                this.view.showDesignationAgentWarning = true
                this.view.designationAgentTip = toolTip
              }
            }
          }
        }
      }
    }
    checkCreditInfo({ [companyId]: companyId }, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  /**
   * 报关行
   */
  async customsBrokerChangeHandler(data) {
    const job = new RailwayExportJob(this.job)
    // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    await job.getLclSlaves()
    for (const slave of job.lclSlaves) {
      if (slave.customsBroker === job.customsBroker) {
        slave.customsBroker = data.value
        this.addLclSlaveToModifiedSet(slave)
      }
    }
    job.customsBroker = data.value
    this.view.context.reloadCharge = true
  }
  // 添加小票信息到被修改的集合中
  addLclSlaveToModifiedSet(slave) {
    const modifiedData = this.context.modifiedData
    modifiedData.lclSlaves = modifiedData.lclSlaves || []
    if (!modifiedData.lclSlaves.includes(slave)) {
      modifiedData.lclSlaves.push(slave)
    }
  }
  /**
   * 运输公司
   */
  carryingCmpChangeHandler(data) {
    const job = this.job
    // 这个验证必须在 job.carryingCmp = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'carryingCmp', this.view.$t('SeaExport.HaulageCompany'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.carryingCmp = data.value
    this.view.context.reloadCharge = true
    if (job.trucking.length === 0) {
      const newData = new TruckingInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.trucking.push(newData)
    }
    const truckingInfo = job.trucking[0]
    truckingInfo.carryingCmp = job.carryingCmp
    if (job.carryingCmp === 0) {
      truckingInfo.driver = ''
      truckingInfo.driverTel = ''
    }
    this.addTruckingToModifiedSet(truckingInfo)
  }
  // 添加truckingInfo到被修改的集合中
  addTruckingToModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    modifiedData.truckingInfo = modifiedData.truckingInfo || []
    if (!modifiedData.truckingInfo.includes(truckingInfo)) {
      modifiedData.truckingInfo.push(truckingInfo)
    }
  }
  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    job.warehouseName = warehouse.warehouseName
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  /**
   * 合并小票唛头、品名
   */
  mergeLclCargoDocInfo(filed, form) {
    const job = this.job
    let mark = ''
    for (const item of job.lclSlaves) {
      if (item[filed]) {
        mark += item[filed] + '\n'
      }
    }
    if (mark) {
      if (!form[filed]) {
        form[filed] = mark
      } else {
        if (!form[filed].endsWith(mark)) {
          form[filed] += '\n' + mark
        }
      }
    }
  }
  /**
  * 当选择销售人员的时候自动关联该销售所在分公司
  */
  async txtSalesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesRecord = job.sales
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = office.chineseName
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'sales')
        const office = await Office.getOfficeByUuid(department.officeUuid)
        job.salesOffice = office.officeId
        job.salesDepartment = department.departmentId
        this.view.txtSalesOffice = office.chineseName
      }
    }
  }
  /**
   * 销售部门修改后，调整分公司信息
   */
  departmentChargeHandler(data) {
    const job = this.job
    const office = Office.getOfficeByUuid(data.officeUuid)
    job.salesDepartment = data.value
    job.salesOffice = office ? office.officeId : 0
    this.view.txtSalesOffice = office ? office.chineseName : ''
  }
  /**
   * 操作改变
   */
  async txtOPChangeHandler(data) {
    const job = this.job
    const user = new User(data)
    job.op = data.value
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      const department = await user.getDefaultDepartment('role', 'op', job.opOffice)
      job.opDepartment = department ? department.departmentId : 0
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value || 0
    job.csrOffice = 0
    job.csrDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'csr')
        job.csrDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        job.csrOffice = office ? office.officeId : 0
      }
    }
  }
  /**
   * 国外客服改变
   */
  async overseaOpChangeHandler(data) {
    const job = this.job
    job.overseaOp = data.value || 0
    job.overseaOpDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'overseaOp', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.overseaOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'overseaOp')
        job.overseaOpDepartment = department ? department.departmentId : 0
      }
    }
  }
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value || 0
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    }
  }
  /**
   * 路线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    job.planner = data.value || 0
    job.plannerDepartment = 0
    job.plannerOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'railwayLine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.plannerOffice = office ? office.officeId : 0
            job.plannerDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'railwayLine')
        job.plannerDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        job.plannerOffice = office ? office.officeId : 0
      }
    }
  }
  async validateForm() {
    const job = this.job
    await JobUtils.checkCustomerBranchScope(job, 'tabBookingMaster')
    if (!job.containerLoadType) {
      throw new TabError(this.view.$t('RailwayExport.TheTypeCannotBeEmpty'), 'tabBookingMaster')
    }
    if (!job.transportType) {
      throw new TabError(this.view.$t('RailwayExport.TransportTypeCannotBeEmpty'), 'tabBookingMaster')
    }
    if (!job.fullHalf) {
      throw new TabError(this.view.$t('RailwayExport.FullJourneyCannotBeEmpty'), 'tabBookingMaster')
    }
    if (!job.transportLine) {
      throw new TabError(this.view.$t('RailwayExport.ShippingRouteCannotBeEmpty'), 'tabBookingMaster')
    }
    if (!job.etd) {
      throw new TabError(this.view.$t('RailwayExport.ETDNotNull'), 'tabBookingMaster')
    }
    if (job.etd && job.eta && job.eta < job.etd) {
      throw new TabError(this.view.$t('RailwayExport.DepartureBeLaterThanDate'), 'tabBookingMaster')
    }
    if (job.lob === 'RI' && !job.eta) {
      throw new TabError(this.view.$t('RailwayExport.ETANotNull'), 'tabBookingMaster')
    }
    if (!job.departureStation) {
      throw new TabError(this.view.$t('RailwayExport.DepartureStationCannotBeEmpty'), 'tabBookingMaster')
    }
    if (job.transfer && !job.transferStation) {
      throw new TabError(this.view.$t('RailwayExport.TransitStationCannotBeEmpty'), 'tabBookingMaster')
    }
    if (!job.transitStation) {
      throw new TabError(this.view.$t('RailwayExport.TransitStationCannotBeEmpty2'), 'tabBookingMaster')
    }
    if (!job.destinationStation) {
      throw new TabError(this.view.$t('RailwayExport.DestinationStationCannotBeEmpty'), 'tabBookingMaster')
    }
    if (job.cargoSource === 'NC' && Number(job.designationAgent) === 0) {
      throw new TabError(this.view.$t('Message.NominatedAgentCannotBeNull'), 'tabBookingMaster')
    }
    if (!job.paymentMethod) {
      throw new TabError(this.view.$t('RailwayExport.PaymentMethodCannotBeEmpty'), 'tabBookingMaster')
    }
    // if (job.sales < 1) {
    //   throw new TabError('销售不能为空', 'tabBookingMaster')
    // }
    // if (job.salesDepartment <= 0) {
    //   throw new TabError(this.view.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingMaster')
    // }
    if (job.op < 1) {
      throw new TabError(this.view.$t('RailwayExport.OperationCannotBeEmpty'), 'tabBookingMaster')
    }
    if (Number(job.opDepartment) === 0) {
      throw new TabError(this.view.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabBookingMaster')
    }
    const seaEQList = this.view.form.seaEQ
    if (!seaEQList || seaEQList.length === 0) {
      throw new TabError(this.view.$t('Message.EQSizeCannotBeNull'), 'tabBookingMaster')
    }
    if (seaEQList && seaEQList.length > 0) {
      if (new Set(seaEQList).size < seaEQList.length) {
        throw new TabError(this.view.$t('SeaExport.RepeatBoxType'), 'tabBookingMaster')
      }
      if (ContainerUtil.checkSeaEqType(job)) {
        throw new TabError(this.view.$t('RailwayExport.AlreadyOtherBoxTypesTime'), 'tabBookingMaster')
      }
      // 中邮定制字段 保存校验
      if (this.view.isZY && !job.saleProductCode) {
        throw new TabError(this.view.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingMaster')
      }
      if (this.view.isZY && !job.fullOrInside) {
        throw new TabError(this.view.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingMaster')
      }
    }
  }
  /**
  * 创建小票
  */
  async selectWindowHandler(value) {
    this.job.chargeWeight = 0
    this.context.loading = true
    try {
      await batchCloneLcLJob({
        jobUuid: this.job.uuid,
        branchId: this.context.office.officeId
      }).then(res => {
        const lclJob = res.data
        lclJob.lclMasterUuid = this.job.uuid
        lclJob.lclMaster = this.job
        lclJob.lclNumber = value
        this.view.$emit('addLcl', lclJob)
      })
    } finally {
      this.context.loading = false
    }
  }
  async slavedAddedHandler(rows) {
    this.context.loading = true
    try {
      const res = await batchAddJob(rows, this.job.uuid, this.job.mbl, this.view.location)
      if (res.data.length > 0) {
        for (const job of res.data) {
          job.version = 0
          job.isCompleteRow = false
        }
        this.view.$emit('addSlavedJob', res.data)
        this.job.lclSlaves.push(...res.data)
        await new RailwayExportJob(this.job).loadJobRelated({ job: true })
        await JobUtils.checkMasterShare(this.job.uuid)
      }
    } finally {
      this.context.loading = false
    }
  }
  /**
    * 批量移出小票
    */
  async btnBatchRemoveClickHandler() {
    const selectedItems = this.view.gridApi.getSelectedRows()
    if (selectedItems.length === 0) {
      throw new ErrorTip('未勾选小票', 'info')
    }
    this.context.loading = true
    try {
      for (const subJob of selectedItems) {
        await new RailwayExportJob(subJob).getContainerUsages()
        if (subJob.quantityActual !== this.getItemLeft(subJob) || subJob.weightActual !== this.getWeightLeft(subJob) ||
            subJob.cubageActual !== this.getCubageLeft(subJob)) {
          throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        }
        for (const c of subJob.containerUsages) {
          if (c.container && c.container.jobUuid && c.container.jobUuid === this.job.uuid) {
            throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
          }
        }
        if (!await SecurityUtil.canOPEditWithAlert(subJob)) {
          return
        }
      }
      const jobKeys = Array.from(selectedItems, p => p.uuid)
      await checkJobForShared(jobKeys).then(res => {
        if (res.data) {
          this.$message.warning(res.data + this.view.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
        } else {
          this.doRemoveJob(jobKeys)
        }
      })
    } finally {
      this.context.loading = false
    }
  }
  async doRemoveJob(jobKeys) {
    const res = await batchRemoveJob(jobKeys, this.view.location)
    await this.onBatchRemoveSucceeded(res.data, jobKeys)
  }
  getItemLeft(input) {
    let quantity = input.quantityActual
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return quantity
  }
  getWeightLeft(input) {
    let weight = input.weightActual
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return weight
  }
  getCubageLeft(input) {
    let cubage = input.cubageActual
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return cubage
  }
  async onBatchRemoveSucceeded(num, removedJobKeys) {
    if (num > 0) {
      this.view.$emit('removeJobFromMaster', removedJobKeys)
      this.job.lclSlaves = ''
      await new RailwayExportJob(this.job).loadJobRelated({ job: true, lclSlaves: true })
    }
  }
  validateDelJobResultHandler(obj) {
    if (obj.hasOwnProperty('status')) {
      this.$confirm(this.view.$t('Message.SureDelete'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        const removedJob = this.view.selectedRow
        this.context.loading = true
        try {
          const res = await batchDeleteJob({ jobKeys: [removedJob.uuid], location: this.view.location })
          await this.delJobResultHandler(res.data, removedJob)
        } finally {
          this.context.loading = false
        }
      }).catch(() => { })
    } else {
      throw new ErrorTip(obj.msg)
    }
  }
  async delJobResultHandler(num, removedJob) {
    if (num > 0) {
      this.view.$emit('removeJob', removedJob.uuid)
      await new RailwayExportJob(this.job).loadJobRelated({ job: true })
      const index = this.job.lclSlaves.findIndex(p => p.uuid === removedJob.uuid)
      if (index > -1) {
        this.job.lclSlaves.splice(index, 1)
      }
      this.$message.success(this.view.$t('Message.DeleteSuccessfully'))
    }
  }
  async fillModel() {
    const model = this.job
    model.customerId = 0
    // 仓库
    this.getWarehouseInfo()
    // 车队
    this.getTruckingInfo()
    // 刷新小票的LOB、POL、POD、ETD、ETA、ATA、Vessel、Voyage、订舱代理、carrier、sailingDay
    for (const slave of model.lclSlaves) {
      // 主票切换业务类型时把小票自定义业务类型清空
      if (slave.lob !== model.lob) {
        slave.customJobType = ''
      }
      slave.lob = model.lob
      if (slave.loadingPortCode !== model.loadingPortCode) {
        slave.loadingPortCode = model.loadingPortCode
      }
      if (slave.etd !== model.etd) {
        slave.etd = model.etd
        slave.sailingDay = model.sailingDay
        if (slave.lob === 'RE') {
          slave.businessDate = slave.etd
        }
      }
      if (slave.atd !== model.atd) {
        slave.atd = model.atd
      }
      if (slave.eta !== model.eta) {
        slave.eta = model.eta
        if (slave.lob === 'RI') {
          slave.businessDate = slave.eta
        }
      }
      if (slave.ata !== model.ata) {
        slave.ata = model.ata
      }
      if (slave.vessel !== model.vessel) {
        slave.vessel = model.vessel
      }
      if (slave.bookingAgent !== model.bookingAgent) {
        slave.bookingAgent = model.bookingAgent
      }
      if (slave.carrierId !== model.carrierId) {
        slave.carrierId = model.carrierId
      }
      if (slave.warehouseCmp !== model.warehouseCmp) {
        slave.warehouseCmp = model.warehouseCmp
      }
      if (slave.destinationAgent !== model.destinationAgent) {
        slave.destinationAgent = model.destinationAgent
      }
      this.addLclSlaveToModifiedSet(slave)
    }
    // 同步报关行
    JobUtils.synCustomsBroker(model, Number(model.customsBroker))
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept1 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept2 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  // CARGO-34439 录完航线后，带出航线负责人
  async refreshPlanner(transportLine) {
    if (transportLine) {
      const pList = []
      const railwayLines = getCacheListByKey(TYPE_NAMES.basic_data_RailwayLine)
      const railwayLine = railwayLines.find(p => p.code === transportLine)
      if (!railwayLine) {
        return
      }
      const plannerList = railwayLine.plannerList
      if (!plannerList) return
      const list = plannerList.split(',')
      let exist = false
      for (const i of list) {
        let plannerId = 0
        const t = i.split('-')
        if (t.length === 2) {
          plannerId = Number(t[1])
          const user = this.userList.find(p => p.userId === plannerId)
          if (user) {
            if (user.userId === this.job.planner) {
              exist = true
              break
            }
            pList.push(user)
          }
        }
      }
      if (pList.length > 0 && !exist) {
        this.job.planner = pList[0].userId
        pList[0].value = pList[0].userId
        this.txtPlannerChangeHandler(pList[0])
      }
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }))
  }

  /**
   * 目的港代理选择
   */
  txtDestinationAgentChangeHandler(data) {
    this.view.showDestinationAgentWarning = false
    this.checkCreditByCompany(data.value, 'destinationAgent')
    const job = this.job
    job.destinationAgent = data.value
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
}
